import React from 'react';
import { View } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import { IconAction } from '../../../design/components';
import { useThemedStyles } from '../../../hooks/useThemedStyles';
import { getMachineDirectionsParams } from '../../docket/docketDetails/DocketLocationDetail';
import { DRIVER_ROUTE } from '../driverRoutes';
import { createStopViewStyles } from '../StopView.styles';

/**
 * StopQuickActions: the stop screen's row of Directions, Photo, New ticket (or
 * Tickets) and Machine info (or Market info).
 * Props: docket, isMarket, canCreateTicket, canSeeMachineDetail, stopActions (useStopActions)
 */
const StopQuickActions = ({ docket, isMarket, canCreateTicket, canSeeMachineDetail, stopActions }) => {
	const navigation = useNavigation();
	const styles = useThemedStyles(createStopViewStyles);

	return (
		<View style={styles.quickActions}>
			<IconAction
				icon="map-pin"
				label="Directions"
				onPress={() => navigation.push('MachineDirectionsView', { ...getMachineDirectionsParams(docket.machine, canSeeMachineDetail), docketId: docket.id })}
				style={styles.quickAction}
			/>
			<IconAction icon="camera" label="Photo" onPress={() => stopActions.openQuickPhoto()} style={styles.quickAction} />
			{canCreateTicket
				? <IconAction icon="plus" label="New ticket" onPress={() => stopActions.openCreateTicket()} style={styles.quickAction} />
				: (
					<IconAction
						icon="tag"
						label="Tickets"
						onPress={() => stopActions.openTickets()}
						disabled={!docket.ticketList?.id}
						style={styles.quickAction}
					/>
				)}
			<IconAction
				icon="info"
				label={isMarket ? 'Market info' : 'Machine info'}
				onPress={() => navigation.push(DRIVER_ROUTE.STOP_MACHINE, { docketId: docket.id })}
				style={styles.quickAction}
			/>
		</View>
	);
};

export default StopQuickActions;
